/** Sprint 5-d PR-4 · fallback 提示 bar（主 AI 不可用·已切換）。 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@mui/material';

interface Props {
  notice: { actual_provider?: string; actual_model?: string; reason?: string } | null;
  onClose?: () => void;
}

const ProviderIndicator: React.FC<Props> = ({ notice, onClose }) => {
  const { t } = useTranslation();
  if (!notice) return null;
  return (
    <Alert severity="warning" onClose={onClose} sx={{ mx: 2, mt: 1 }}>
      {t('chat.fallbackNotice', '主要 AI 服務暫時不可用，已切換至備援（{{model}}）', {
        model: notice.actual_model || notice.actual_provider || '',
      })}
    </Alert>
  );
};

export default ProviderIndicator;
